<div class="inspection-modal">
  <div class="top">
    <div class="heading">
      Query Application
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()"
      >close</i
    >
  </div>
  <div class="form-wrapper">
    <form [formGroup]="form">
      <div class="form-fields">
        <div class="field">
          <label for="inspectors" class="mb-2">COMMENT</label>
          <textarea
            name=""
            formControlName="comment"
            class="form-control"
          ></textarea>

          <small
            *ngIf="
              isSubmitAttempted && comment?.invalid && !isCurrentOfficerLoading
            "
            class="error-message"
          >
            {{ getErrorMessage(comment) }}
          </small>
        </div>
      </div>

      <div class="modal-actions-wrapper">
        <button
          type="submit"
                class="submit btn btn-danger w-100 d-flex justify-content-center"

          (click)="approveOrQueryApplication()"
          [disabled]="form.invalid"
        >
          @if(!isSubmitting){
          <span>
            QUERY
          </span>
          } @else {
          <span class="spinner-light"></span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
